import styled from "styled-components";
import individualIcon from "../assets/images/individualIcon.svg";
import picture1 from "../assets/images/Picture1.png";
import picture2 from "../assets/images/Picture2.png";
import picture3 from "../assets/images/Picture3.png";
import { Link } from "react-router-dom";
import { SecondaryButton } from "../styles/Button.styles";
import { device } from "../styles/Responsive.style";


const Individuals = () => {
    return (
        <PageWrapper>
            <Top>
                <img src={individualIcon} alt="individual icon"/>
                <h1>Find your place in the world of digital</h1>
                <p>The attriDNA questionnaire helps you understand the attributes that define how you work, think, and thrive. In just a few minutes, you’ll reveal your unique profile — a mirror of the qualities employers value most in the modern workplace. Our questionnaire can be customised to align with your organisation's specific needs, enhancing your ability to identify attributes in new hires that reflect your existing team's strengths. It serves as an instrument for identifying attributes in prospective candidates and existing staff that are reflective of the core competencies within your team.</p>
            </Top>
            <QuoteBlock>
                <div>❞</div>
                <p>The guidance from Code Nation made learning really enjoyable and impactful, further fuelling my interest in Cyber Security. I intend to accelerate my understanding by continuing to explore technology in 2025</p>
                <h4>-Participant</h4>
            </QuoteBlock>
            <Middle>
                <h3>How it works</h3>
                <h4>1. Click to complete the questionnaire</h4>
                <p>Take a short assessment that identifies your workplace attributes — from problem-solving and adaptability to teamwork and creativity.</p>
                <h4>2. View your personalised profile</h4>
                <p>See where your strengths lie, and how they compare to the digital economy’s most in-demand roles.</p>
                <h4>3. Share and grow</h4>
                <p>Use your insights to showcase your potential to employers, guide your career choices, and focus your personal development.</p>
                <div>
                    <img src={picture1} alt="questionnaires" />
                    <img src={picture2} alt="questionnaire" />
                    <img src={picture3} alt="results" />
                </div>
            </Middle>
            <QuoteBlock>
                <div>❞</div>
                <p>The attriDNA process was straightforward and easy to follow. Everything was clearly explained, making each step simple to complete</p>
                <h4>-Participant</h4>
            </QuoteBlock>
            <Bottom>
                <h3>Benefits for you</h3>
                <h4>Know your strengths - Understand what makes you valuable in the digital economy.</h4>
                <h4>Stand out to employers - Present your unique attribute profile, not just your CV.</h4>
                <h4>Plan your next step - Identify roles and pathways that match your attributes.</h4>
                <h4>Grow with confidence - Get actionable insights you can use to improve and develop.</h4>
            </Bottom>
            <Banner>
                <h2>Complete your questionnaire</h2>
                <Link to="/invite/7e9373d3-6a3a-4e19-bbd2-815c8288c869/68e6c75a0c591744e47b0702">
                    <SecondaryButton>
                        Click Here
                    </SecondaryButton>
                </Link>
            </Banner>
        </PageWrapper>
    )
}

export default Individuals;

const PageWrapper = styled.main`
    width: 100%;
    max-width: 1500px;
    padding: 0 50px;
    box-sizing: border-box;
    margin: 0 auto;
`

const QuoteBlock = styled.div`
    position: relative;
    background: var(--bg-main-light);
    border-radius: 10px;
    padding: 40px 80px;
    margin: 80px 0 40px 0;

    div {
        font-size: 180px;
        color: var(--secondary-gray);
        position: absolute;
        top: -95px;
        left: 40px;
    }

    p {
        margin: 0;
    }

    h4 {
        margin: 5px 0 0 0;
        text-align: right;
    }
`;

const Top = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 40px 0;

    img {
        height: 100px;
    }
`;

const Middle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    div {
        display: flex;
        justify-content: space-around;

        img {
            width: 30%;
            height: auto;
            object-fit: contain;
        }
    }

    h3 {
        font-size: var(--font-medium);
        margin: 10px 0;
    }

    h4 {
        margin-bottom: 0;
    }
    p {
        margin-top: 0;
    }

    @media ${device.medium} {
        div {
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            img {
                width: 100%;
                margin: 10px 0;
                height: auto;
            }
        }
    }
`;

const Bottom = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 40px 0;

    h3 {
        font-size: var(--font-medium);
        margin: 10px 0;
    }

    h4 {
        background: var(--bg-main-light);
        padding: 20px;
        width: 100%;
        border-radius: 5px;
        margin: 5px;
        box-sizing: border-box;
        font-weight: 400;
    }
`;

const Banner = styled.div`
    border-radius: 10px;
    background: linear-gradient(45deg, var(--accent), var(--orange));
    display: grid;
    place-items: center;
    padding: 40px 10px;

    h2 {
        margin: 0;
        font-size: var(--font-medium);
    }

    a {
        background: white;
        color: black;
        text-decoration: none;
        padding: 5px;
        border-radius: 10px;
        margin-top: 20px;
    }
`;